// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"5349d71b","453":"042cdbb2","796":"882440e2"}[chunkId] + ".chunk.js";
};